interface ComorbiditiesMenuProps {
  setDisplayValue: (val: number) => void;
  displayValue: number;
  clear: boolean;
  setClear: (val: boolean) => void;
  setIsFiltersOpen?: () => void;
}
const ComorbiditiesMenu: React.FC<ComorbiditiesMenuProps> = ({
  setDisplayValue,
  displayValue,
  setClear,
  clear,
  setIsFiltersOpen,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDisplayValue(Number(event.target.value));
    setClear(false);
    setIsFiltersOpen?.();
  };
  return (
    <ul>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={4}
            checked={!clear && displayValue === 4}
            onChange={handleChange}
          />
          <div className="text-valmidnight text-base ml-2">
            Atrial Fibrillation
          </div>
        </label>
      </li>

      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={5}
            checked={!clear && displayValue === 5}
            onChange={handleChange}
          />
          <div className="text-valmidnight text-base ml-2">Atrial Flutter</div>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={6}
            checked={!clear && displayValue === 6}
            onChange={handleChange}
          />
          <div className="text-valmidnight text-base ml-2">
            Acute Myocardial Infarction
          </div>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={7}
            checked={!clear && displayValue === 7}
            onChange={handleChange}
          />
          <div className="text-valmidnight text-base ml-2">
            Coronary Artery Disease
          </div>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={8}
            checked={!clear && displayValue === 8}
            onChange={handleChange}
          />
          <div className="text-valmidnight text-base ml-2">COPD</div>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={9}
            checked={!clear && displayValue === 9}
            onChange={handleChange}
          />
          <div className="text-valmidnight text-base ml-2">
            Diabetes mellitus
          </div>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={10}
            checked={!clear && displayValue === 10}
            onChange={handleChange}
          />
          <div className="text-valmidnight text-base ml-2">Dyslipidemia</div>
        </label>
      </li>

      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={11}
            checked={!clear && displayValue === 11}
            onChange={handleChange}
          />
          <div className="text-valmidnight text-base ml-2">
            Congestive Heart Failure
          </div>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={12}
            checked={!clear && displayValue === 12}
            onChange={handleChange}
          />
          <div className="text-valmidnight text-base ml-2">Hypertension</div>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={13}
            checked={!clear && displayValue === 13}
            onChange={handleChange}
          />
          <div className="text-valmidnight text-base ml-2">Obesity</div>
        </label>
      </li>

      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={14}
            checked={!clear && displayValue === 14}
            onChange={handleChange}
          />
          <div className="text-valmidnight text-base ml-2">Renal Failure</div>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={15}
            checked={!clear && displayValue === 15}
            onChange={handleChange}
          />
          <div className="text-valmidnight text-base ml-2">Smoker</div>
        </label>
      </li>

      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={16}
            checked={!clear && displayValue === 16}
            onChange={handleChange}
          />
          <div className="text-valmidnight text-base ml-2">Stroke</div>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={17}
            checked={!clear && displayValue === 17}
            onChange={handleChange}
          />
          <div className="text-valmidnight text-base ml-2">
            Ventricular Fibrillation
          </div>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={18}
            checked={!clear && displayValue === 18}
            onChange={handleChange}
          />
          <div className="text-valmidnight text-base ml-2">
            Ventricular Tachycardia
          </div>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={19}
            checked={!clear && displayValue === 19}
            onChange={handleChange}
          />
          <div className="text-valmidnight text-base ml-2">
            Supraventricular Tachycardia
          </div>
        </label>
      </li>
    </ul>
  );
};

export default ComorbiditiesMenu;
